import { Component } from 'react'
import { Subject } from 'rxjs'
import { debounceTime, takeUntil } from 'rxjs/operators'
import { resizeObservable$ } from 'DOMEvents'
import { VIEWPORTS } from 'constants/screenSize'
import { getNewMediaQueries } from 'domain/screenSize'
import withConnect from './connector'

// type Props = {
//   +onWindowResize: ScreenSizeType => void,
//   +screenSize: ScreenSizeType
// }

class ScreenSize extends Component {
  handleResize = () => {
    this.props.onWindowResize(getNewMediaQueries(VIEWPORTS))
  }

  componentDidMount () {
    this.props.onWindowResize(getNewMediaQueries(VIEWPORTS))
    this.stopSubscription = new Subject()
    this.subscription = resizeObservable$
      .pipe(
        debounceTime(50),
        takeUntil(this.stopSubscription)
      )
      .subscribe(this.handleResize)
  }

  componentWillUnmount () {
    this.stopSubscription.next(true)
  }

  render () {
    return null
  }
}

export default withConnect(ScreenSize)
